import { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  LineChart,
  Line,
  PieChart,
  Pie,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import api from "../api/axios";

const COLORS = [
  "#0d6efd",
  "#198754",
  "#ffc107",
  "#dc3545",
  "#6f42c1",
];

export default function DashboardCharts() {
  const [statusData, setStatusData] = useState([]);
  const [counterData, setCounterData] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const [weeklyData, setWeeklyData] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

// const { data } = await api.get(
//   `/Dashboard?fromDate=${fromDate}&toDate=${toDate}`
// );

// setSummary(data.summary);
// setStatusChart(data.statusChart);
// setCounterChart(data.counterChart);
// setServiceChart(data.serviceChart);
// setWeeklyChart(data.weeklyChart);



  const loadData = async () => {
    try {
      const [status, counter, service, weekly] = await Promise.all([
        api.get("/Report/TodayStatus"),
        api.get("/Report/CounterReport"),
        api.get("/Report/ServiceReport"),
        api.get("/Report/WeeklyReport"),
      ]);

      setStatusData([
        { name: "Waiting", value: status.data.waiting },
        { name: "Serving", value: status.data.serving },
        { name: "Completed", value: status.data.completed },
        { name: "Skipped", value: status.data.skipped },
      ]);

      setCounterData(counter.data);
      setServiceData(service.data);
      setWeeklyData(weekly.data);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="container-fluid">

      <div className="row">

        <div className="col-lg-6 mb-4">
          <div className="card shadow">
            <div className="card-header fw-bold">
              Today's Token Status
            </div>

            <div className="card-body">

              <ResponsiveContainer width="100%" height={300}>
                <BarChart data={statusData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Legend />

                  <Bar dataKey="value" fill="#0d6efd" radius={[5,5,0,0]} />
                </BarChart>
              </ResponsiveContainer>

            </div>
          </div>
        </div>

        <div className="col-lg-6 mb-4">
          <div className="card shadow">
            <div className="card-header fw-bold">
              Weekly Token Trend
            </div>

            <div className="card-body">

              <ResponsiveContainer width="100%" height={300}>
                <LineChart data={weeklyData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="day" />
                  <YAxis />
                  <Tooltip />
                  <Legend />

                  <Line
                    type="monotone"
                    dataKey="count"
                    stroke="#198754"
                    strokeWidth={3}
                  />

                </LineChart>
              </ResponsiveContainer>

            </div>
          </div>
        </div>

        <div className="col-lg-6 mb-4">

          <div className="card shadow">

            <div className="card-header fw-bold">
              Counter Performance
            </div>

            <div className="card-body">

              <ResponsiveContainer width="100%" height={300}>

                <BarChart data={counterData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="counter" />
                  <YAxis />
                  <Tooltip />

                  <Bar
                    dataKey="completed"
                    fill="#ffc107"
                  />

                </BarChart>

              </ResponsiveContainer>

            </div>

          </div>

        </div>

        <div className="col-lg-6 mb-4">

          <div className="card shadow">

            <div className="card-header fw-bold">
              Service Wise Tokens
            </div>

            <div className="card-body">

              <ResponsiveContainer width="100%" height={300}>

                <PieChart>

                  <Pie
                    data={serviceData}
                    dataKey="count"
                    nameKey="service"
                    outerRadius={100}
                    label
                  >
                    {serviceData.map((entry, index) => (
                      <Cell
                        key={index}
                        fill={COLORS[index % COLORS.length]}
                      />
                    ))}
                  </Pie>

                  <Tooltip />
                  <Legend />

                </PieChart>

              </ResponsiveContainer>

            </div>

          </div>

        </div>

      </div>

    </div>
  );
}